
import { useRef } from 'react'
import { useAnimationFrame } from 'framer-motion'


interface Logo {
  src: string
  alt: string
}

const logos: Logo[] = [
  { src: '/color_bootroom.svg', alt: 'Bootroom' },
  { src: '/botButlerlogo.svg', alt: 'Bot Butler' },
  { src: '/color_forSent.svg', alt: 'ForSent' },
  { src: '/color_vomax.png', alt: 'VOMax' },
  { src: '/color_Gdd.svg', alt: 'GDD' },
  { src: '/color_laboucle.svg', alt: 'La Boucle' },
  { src: '/color_maya.svg', alt: 'Maya' },
  { src: '/color_napchief.svg', alt: 'NapChief' },
  { src: '/color_nexstaff.svg', alt: 'NexStaff' },
  { src: '/color_nikben.svg', alt: 'Nikben' },
  { src: '/color_obm.svg', alt: 'OBM' },
  { src: '/color_rs.png', alt: 'RS' },
  { src: '/color_s2h.svg', alt: 'S2H' },
  { src: '/relybluesvg.svg', alt: 'RelyBlue' },
]

function InnerHeroSlider(): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)
  const x = useRef<number>(0)

  useAnimationFrame((_time, delta) => {
    if (containerRef.current) {
      x.current -= 0.04 * delta

      containerRef.current.style.transform = `translateX(${x.current}px)`

      // Reset position for infinite loop
      const scrollWidth = containerRef.current.scrollWidth / 2

      if (Math.abs(x.current) >= scrollWidth) {
        x.current = 0
      }
    }
  })

  return (
    <section className="container-fluid mx-1">
      <div className={`row brandsection`}>
        <div className="col-12">
          <div className="sliderWrapper">
            <div className="sliderMask">
              <div
                className="sliderTrack"
                ref={containerRef}
              >
                {[...logos, ...logos].map((logo, index) => (
                  <div
                    className="slide"
                    key={`${logo.alt}-${index}`}
                  >
                    <img
                      src={logo.src}
                      alt={logo.alt}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default InnerHeroSlider

